export default "__VITE_ASSET__Cs9d6CrL__"